import { GastroCard, GastroCardCode } from '@models/app-state'
import { useSelector } from 'react-redux'
import { selectAppData } from '@store/slices/app-slice'

export const useGastroCardProduct = (code: GastroCardCode): GastroCard => {
  const { gastro_cards } = useSelector(selectAppData)

  return gastro_cards.find(gastroCard => gastroCard.code === code) as GastroCard
}
